import {useTheme} from 'styled-components/native';
import {Link as NBLink} from 'native-base';
import React from 'react';

export interface LinkProps {
  href: string;
  isExternal?: boolean;
  text: string;
}

const Link: React.FC<LinkProps> = ({href, text, isExternal = false}) => {
  const theme = useTheme() as any;
  const {caesarRewards} = theme.colors;

  return (
    <NBLink
      href={href}
      isExternal={isExternal}
      isUnderlined={false}
      _text={{
        color: caesarRewards,
        fontSize: 3,
        fontWeight: '600',
        fontFamily: 'body',
      }}
      _hover={{
        isUnderlined: true,
        _text: {fontWeight: '700', color: caesarRewards},
      }}>
      {text}
    </NBLink>
  );
};

export default Link;
